var _path, _path2, _circle, _path3, _path4, _path5, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtmLillust1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.996,
    height: 218.083,
    viewBox: "0 0 192.996 218.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_790",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 790",
    transform: "translate(-363.009 -2810.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_708",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 708",
    transform: "translate(-726.743 2177.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_706",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 706",
    transform: "translate(1089.752 638.288)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_175",
    "data-name": "\\u30D1\\u30B9 175",
    d: "M1153.613,771.766a24.922,24.922,0,0,1-6.181-.8l-.4-.111-.369-.185A102.429,102.429,0,0,1,1113.2,744.4a99.446,99.446,0,0,1-16.9-30,115.464,115.464,0,0,1-6.531-40.678c.006-.291.01-.516.01-.67a16.018,16.018,0,0,1,9.515-15.04c4.423-1.844,44.588-18.341,47.491-19.533,5.465-2.739,11.3-.453,12.229-.053,2.093.856,39.223,16.042,47.246,19.863,8.27,3.937,10.476,11.012,10.476,14.57a118.655,118.655,0,0,1-8.294,44.758,103.643,103.643,0,0,1-18.625,30.017c-15.2,17.11-30.412,23.175-30.558,23.229A16.622,16.622,0,0,1,1153.613,771.766Zm-3.577-8.859c1.319.3,4.355.74,6.334.018,2.513-.917,15.242-7.517,27.136-20.9,16.434-18.494,24.774-41.742,24.785-69.1-.03-.555-.423-4.507-5.658-7-7.867-3.746-46.461-19.527-46.85-19.687l-.107-.045c-.809-.338-3.382-1.052-5.158-.122l-.355.165c-.43.178-43.065,17.689-47.613,19.583-3.18,1.325-4.314,4.61-4.314,7.24,0,.193-.005.472-.012.834C1097.861,692.606,1102.193,738.668,1150.036,762.907Z",
    transform: "translate(-1089.752 -637.154)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_176",
    "data-name": "\\u30D1\\u30B9 176",
    d: "M1147.618,641.38s-43.022,17.671-47.632,19.592-6.914,6.529-6.914,11.139-3.458,64.76,54.546,93.841c0,0,5.265,1.456,9.259,0s54.7-26.041,54.7-94.033c0,0,0-6.914-8.067-10.756s-47.069-19.783-47.069-19.783S1151.652,639.268,1147.618,641.38Z",
    transform: "translate(-1088.811 -636.212)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_177",
    "data-name": "\\u30D1\\u30B9 177",
    d: "M1148.626,651.92v94.264s-43.407-20.895-43.022-75.826Z",
    transform: "translate(-1085.21 -632.922)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_25",
    "data-name": "\\u6955\\u5186\\u5F62 25",
    cx: 22.515,
    cy: 22.515,
    r: 22.515,
    transform: "translate(1167.387 633.195)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_178",
    "data-name": "\\u30D1\\u30B9 178",
    d: "M1183.087,648.74l-3.4-4.8-14.06,9.951-1.658-4.622-5.541,1.987,4.273,11.918Z",
    transform: "translate(19.68 3.078)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_179",
    "data-name": "\\u30D1\\u30B9 179",
    d: "M1159.835,692.051a1.494,1.494,0,0,1,1.489,1.488h0a1.493,1.493,0,0,1-1.489,1.489h-9.282v7h13.957a8.491,8.491,0,0,0,0-16.981h-13.957v7Z",
    transform: "translate(17.423 14.859)",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_180",
    "data-name": "\\u30D1\\u30B9 180",
    d: "M1135.271,695.029a1.489,1.489,0,0,1,0-2.977h9.281v-7H1130.6a8.491,8.491,0,0,0,0,16.981h13.955v-7Z",
    transform: "translate(9.272 14.859)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_707",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 707",
    transform: "translate(1121.054 686.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_181",
    "data-name": "\\u30D1\\u30B9 181",
    d: "M1118.423,701.508a8.5,8.5,0,0,1,5.2-10.825l13.165-4.626-1.279-3.641-13.167,4.626a12.35,12.35,0,0,0,8.189,23.3l13.165-4.627-1.279-3.641-13.167,4.625A8.5,8.5,0,0,1,1118.423,701.508Z",
    transform: "translate(-1114.083 -672.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_182",
    "data-name": "\\u30D1\\u30B9 182",
    d: "M1154.279,675.33l-13.167,4.625,1.279,3.642,13.167-4.626a8.49,8.49,0,0,1,5.63,16.02l-13.167,4.626,1.279,3.642,13.167-4.626a12.35,12.35,0,0,0-8.188-23.3Z",
    transform: "translate(-1106.337 -674.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_183",
    "data-name": "\\u30D1\\u30B9 183",
    d: "M1158.8,687.17a1.492,1.492,0,0,0,.911-1.9h0a1.492,1.492,0,0,0-1.9-.911l-8.756,3.076-13.352,4.692-8.758,3.076a1.489,1.489,0,0,0,.987,2.81l8.757-3.077,13.352-4.691Z",
    transform: "translate(-1110.681 -671.866)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_714",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 714",
    transform: "translate(14.962 2791.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_286",
    "data-name": "\\u30D1\\u30B9 286",
    d: "M547.2,528.952h5.281L555,508.583H547.2Z",
    transform: "translate(-40.28 -296.728)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_287",
    "data-name": "\\u30D1\\u30B9 287",
    d: "M543.261,563.187h10.4a6.628,6.628,0,0,1,6.628,6.628v.215H543.261Z",
    transform: "translate(-37.684 -332.687)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_288",
    "data-name": "\\u30D1\\u30B9 288",
    d: "M599.2,528.952h5.281L607,508.583H599.2Z",
    transform: "translate(-74.524 -296.728)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_289",
    "data-name": "\\u30D1\\u30B9 289",
    d: "M595.261,563.187h10.4a6.628,6.628,0,0,1,6.628,6.628v.215H595.261Z",
    transform: "translate(-71.928 -332.687)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_290",
    "data-name": "\\u30D1\\u30B9 290",
    d: "M536.152,348.647l1.267,64.621-10.247-.635-7.109-41.16-2.245-28.064Z",
    transform: "translate(-20.928 -187.953)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_291",
    "data-name": "\\u30D1\\u30B9 291",
    d: "M553.739,297.383l1.436,76.5-11.951-.341-2.581-45.472-4.49-16.464L517.818,303l2.993-20.58,26.941-.374Z",
    transform: "translate(-20.929 -147.541)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_77",
    "data-name": "\\u6955\\u5186\\u5F62 77",
    cx: 9.164,
    cy: 9.164,
    r: 9.164,
    transform: "translate(503.042 63.039)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_292",
    "data-name": "\\u30D1\\u30B9 292",
    d: "M550.839,137.738l1.4,2.127,3.742,10.477-2.994,40.786L535.4,191.5l-2.245-46.773,4.7-5.879Z",
    transform: "translate(-31.032 -52.511)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_293",
    "data-name": "\\u30D1\\u30B9 293",
    d: "M495.018,160.777l-2.993-.374s-.748.374-1.123,2.994-4.864,25.819-4.864,25.819l5.987,28.438,6.735-8.98-4.116-15.716,4.116-15.716Z",
    transform: "translate(0 -67.437)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_294",
    "data-name": "\\u30D1\\u30B9 294",
    d: "M615.454,160.4H617.7l5.613,30.308-5.239,23.573-5.239-8.606,1.5-9.355-.748-8.232-2.619-4.865Z",
    transform: "translate(-82.269 -67.437)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_295",
    "data-name": "\\u30D1\\u30B9 295",
    d: "M547.2,72.2l-1.666-.417s-1.25-7.081-4.165-6.248-10.414,1.666-10.414-1.666,7.081-6.248,11.247-5.831,9.485,1.8,10.83,7.914c2.156,9.8-4.448,12.28-4.448,12.28l.11-.357A5.56,5.56,0,0,0,547.2,72.2Z",
    transform: "translate(-29.582 0)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_296",
    "data-name": "\\u30D1\\u30B9 296",
    d: "M504.668,144.888l11.974-4.864,2.806-2.058,8.419,37.231,3.929-38.353,15.528,8.045-5.238,25.444-.748,9.729,2.245,7.858s7.858,5.613,5.239,11.6-5.613,6.361-5.613,6.361-12.722-11.974-13.47-14.967-1.871-8.232-1.871-8.232-6.361,23.948-13.845,23.573-7.484-8.232-7.484-8.232l1.871-8.232,2.994-8.606-1.5-14.219Z",
    transform: "translate(-12.269 -51.921)",
    fill: "#2f2e41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmLillust1);
export default __webpack_public_path__ + "static/media/HTMLillust_1.c2830d7f11d0711de10f8a5d2d36ba61.svg";
export { ForwardRef as ReactComponent };